module.exports = __webpack_public_path__ + "img/1584306731.ac786598.jpg";